export const Bullet = () => {
  return <div className={`relative h-2 w-2 rounded-full bg-primary`} />
}
